var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRank28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C18 24.2091 16.2091 26 14 26C11.7909 26 10 24.2091 10 22C10 19.7909 11.7909 18 14 18C16.2091 18 18 19.7909 18 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3L4.98368 12.2572C5.57649 15.0236 8.02127 17 10.8505 17H13L10 3H3ZM5.47397 5L6.93929 11.8381C7.31143 13.5748 8.77837 14.8445 10.5232 14.9867L8.38317 5H5.47397Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 3L23.0163 12.2572C22.4235 15.0236 19.9787 17 17.1495 17H15L18 3H25ZM22.526 5L21.0607 11.8381C20.6886 13.5748 19.2216 14.8445 17.4768 14.9867L19.6168 5H22.526Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRank28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;